module.exports = __webpack_public_path__ + "a8689e20df5b1e346ee8cb499648b8c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/images/works/onepage_slide_pipilotti_1.jpg
// module id = 888
// module chunks = 0